//@ts-check

let inited = false;
let callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = (rule, cb) => {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Giftbox', 'inited', (p, widget) => {
			const master_sendGifts = widget.sendGifts;

			widget.sendGifts = (data, ...args) => callback().then(({ result, params }) => {
				if (result === true) {
					return master_sendGifts.apply(widget, [
						{
							...data,
							...params
						},
						...args
					]);
				}
			});
		}, {
			sync: true,
			prefix: 'user_access_patch_giftbox'
		});
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/patch-giftbox.es.js